import { css } from '@emotion/css';
import { breakpoints } from '@/css/resources/variables.css';
import { gridColumnGap } from '@/css/resources/placeholders.css';

const getStyles = () =>
	css(gridColumnGap, {
		display: 'grid',

		[`@media (min-width: ${breakpoints.mobile})`]: {
			gridTemplateColumns: 'repeat(2, 1fr)',
		},
	});

export { getStyles };
